import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { Container, Grid, Typography, Button } from "@material-ui/core";
import "./Partners.css";
import OpenGraphMeta from "../../components/SEO/OpenGraphMeta.jsx";

const useStyles = makeStyles((theme) => ({
	partners: {
		minHeight: "100vh",
		width: "100%",
		overflow: "hidden",
		display: "flex",
		background:
			"linear-gradient(61.54deg, #e5e7eb -48.56%, #e5e7eb -48.55%, #f8fbfa 72.22%)",
		position: "relative",
		alignItems: "center",
	},
	container: {},
	leftContainer: {},
	rightContainer: {},
}));

const Partners = () => {
	const classes = useStyles();
	return (
		<div className={classes.partners}>
			<Helmet>
				<title>Our Partners | Technology Solutions | Kinetx Co</title>
				<meta 
					name="description" 
					content="Kinetx Co partners with leading technology providers to deliver best-in-class IT infrastructure solutions for Miami and NYC businesses." 
				/>
				<link rel="canonical" href="https://www.kinetx.co/partners" />
			</Helmet>
			<OpenGraphMeta
				title="Our Partners | Technology Solutions | Kinetx Co"
				description="Kinetx Co partners with leading technology providers to deliver best-in-class IT infrastructure solutions for Miami and NYC businesses."
				url="https://www.kinetx.co/partners"
			/>
			<Container maxWidth="lg" className={classes.container}>
				<Grid container>
					<Grid
						item
						md={6}
						sm={12}
						xs={12}
						className={classes.leftContainer}
					></Grid>
					<Grid
						item
						md={6}
						sm={12}
						xs={12}
						className={classes.rightContainer}
					></Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default Partners;
